import { render, staticRenderFns } from "./SolicitacaoEditar.vue?vue&type=template&id=b012b1c4&"
import script from "./SolicitacaoEditar.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoEditar.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoEditar.vue?vue&type=style&index=0&id=b012b1c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports